import { primaryButtonClass } from "../ui";
import type { CompletionRule } from "../../types";

export function ManualCompleteButton({
  done,
  onClick,
  rule,
}: {
  done: boolean;
  onClick: () => void;
  rule: CompletionRule;
}) {
  if (rule === "manual_approval") {
    return (
      <p className="rounded-md bg-warning-bg px-3 py-2.5 text-center text-sm font-medium text-warning-text">
        {done ? "Approved" : "Awaiting facilitator approval"}
      </p>
    );
  }
  if (rule !== "manual") return null;
  return (
    <button className={primaryButtonClass} onClick={onClick} disabled={done}>
      {done ? "Completed" : "Mark complete"}
    </button>
  );
}
